"use client";

import * as React from "react";
import { extractStrapiMediaUrl } from "@/lib/strapi";
import { useBrandStore } from "@/stores/brand";

function upsertLink(rel: string, href: string) {
  const selector = `link[rel="${CSS.escape(rel)}"]`;
  const existing = document.head.querySelector(selector) as HTMLLinkElement | null;
  if (existing) {
    existing.href = href;
    return;
  }

  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  document.head.appendChild(link);
}

export function DynamicFavicon(): null {
  const { brand } = useBrandStore();

  const faviconUrl = React.useMemo(
    () => extractStrapiMediaUrl(brand?.attributes?.contact_info?.favicon),
    [brand],
  );

  React.useEffect(() => {
    if (!faviconUrl) return;
    upsertLink("icon", faviconUrl);
    upsertLink("shortcut icon", faviconUrl);
  }, [faviconUrl]);

  return null;
}
